module.exports = "https://coursera_assets.s3.amazonaws.com/images/925079677f7ae635cddb669906288bd4.svg";